



















import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { ExplorerView, MdTable, MdTableFragmentDoc } from '@/module/graphql'
import LolthExplorer from '@/module/components/lolth-explorer/index.vue'
import gql from 'graphql-tag'

@Component({
  components: {
    CmpMdTableDataDialog: () => import('@/module/butler/views/components/cmp-md-table-data-dialog.vue')
  },
  name: 'explorer-view-switch-widget'
})
export default class ExplorerViewSwitchWidget extends Vue {
  @Prop({ required: true }) view: ExplorerView
  @Prop({ required: true }) explorerViews: ExplorerView[]

  @Inject()
  readonly explorer: LolthExplorer

  private mMdTableDataDialogVisible: boolean = false
  private mMdTable: MdTable = null

  get currentView() {
    return this.explorer.currentView
  }

  public attachToParent(parent: HTMLElement) {
    this.$el.classList.remove('hidden')
    parent.prepend(this.$el)
  }

  private onExplorerViewChanged(view: ExplorerView) {
    if (!view.relatedMdTableCode) {
      this.explorer.switchView(view)
    } else {
      this.$apollo.query({
        query: gql`query {
        MdTable(id: "${view.relatedMdTableCode}") {
          ...mdTable
        }
      }${MdTableFragmentDoc}`
      }).then(resp => {
        this.mMdTable = resp.data.MdTable
        this.mMdTableDataDialogVisible = true
      })
    }
  }
}
